import { useTranslation } from "react-i18next";
import FilterDatePicker from "./FilterDatePicker";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, useTheme } from "@mui/material";

type Props = {};

export const FilterDate = (props: Props) => {
  const now = dayjs();
  const location = useLocation();
  const search = location.search;
  const params = new URLSearchParams(search);
  const from = params.get("from");
  const to = params.get("to");
  // state
  const [dateFrom, setDateFrom] = useState(from ? dayjs(from) : null);
  const [dateTo, setDateTo] = useState(to ? dayjs(to) : null);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const from = dayjs(dateFrom);
    const to = dayjs(dateTo);
    !dateFrom
      ? params.delete("from")
      : params.set("from", from.format("YYYY-MM-DD"));
    !dateTo ? params.delete("to") : params.set("to", to.format("YYYY-MM-DD"));
    navigate(`?${params.toString()}`);
  }, [dateFrom, dateTo, navigate]);

  useEffect(() => {
    if (location.search.length > 0) return;
    const params = new URLSearchParams(search);
    const from = params.get("from");
    const to = params.get("to");
    setDateFrom(from ? dayjs(from) : null);
    setDateTo(to ? dayjs(to) : null);
  }, [location]);

  return (
    <>
      <Typography
        component="span"
        sx={{ fontSize: "14px" }}
        color={theme.palette.base.contrast}
      >
        {t("DATE_TAKEN")}
      </Typography>
      <FilterDatePicker
        label={"From"}
        value={dateFrom}
        setValue={setDateFrom}
        shouldDisableDate={(date) => {
          return dayjs(date).isAfter(dateTo);
        }}
      />
      <Typography
        component="span"
        color={theme.palette.base.contrast}
        sx={{ fontSize: "20px" }}
      >
        ～
      </Typography>
      <FilterDatePicker
        label={"To"}
        value={dateTo}
        setValue={setDateTo}
        shouldDisableDate={(date) => {
          return dayjs(date).isBefore(dateFrom);
        }}
      />
    </>
  );
};
